var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipmateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9216 33.8119V33.8191L23.7998 33.3069L22.9216 33.8119Z",
    fill: "#5747FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4198 15.1893L18.8356 20.1506C18.5179 20.3344 18.127 20.3344 17.8092 20.1506L9.08758 15.1161V47.0289L0.512302 42.0765C0.194567 41.8927 0 41.5536 0 41.1878V0.871222C0 0.201986 0.724721 -0.217401 1.30485 0.118109L27.4216 15.1893H27.4198Z",
    fill: "#5747FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7998 33.3069L22.9216 33.8191V33.8119L23.7998 33.3069Z",
    fill: "#5747FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.7998 33.3069L22.9216 33.8191V33.8119L23.7998 33.3069Z",
    fill: "#5747FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4253 0.876471V41.2894C64.4253 41.5999 64.261 41.8855 63.9951 42.0443L55.327 47.0466V4.61884L63.1204 0.123358C63.7005 -0.212152 64.4253 0.207235 64.4253 0.876471Z",
    fill: "#5747FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.7998 33.3069L22.9216 33.8191V33.8119L23.7998 33.3069Z",
    fill: "#5747FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.7998 33.3069L22.9216 33.8191V33.8119L23.7998 33.3069Z",
    fill: "#5747FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5895 33.3712V11.1293C50.5895 9.45355 48.7741 8.40598 47.3229 9.24297L14.6944 28.0726C14.1607 28.3813 13.8322 28.9506 13.8322 29.5663V49.7665L30.9881 59.6694C31.7521 60.1102 32.6928 60.1102 33.455 59.6694L50.5913 49.7772V39.2872L32.9231 49.4899C32.4893 49.7398 31.9556 49.7398 31.5218 49.4899L28.4516 47.7142C28.0214 47.4661 28.0232 46.8451 28.4516 46.597L50.1986 34.0493C50.4414 33.9083 50.5913 33.6496 50.5913 33.3694L50.5895 33.3712ZM22.9216 38.6483V34.2403C22.9216 33.9744 23.0644 33.7281 23.2946 33.596L41.0128 23.3754C41.2306 23.2505 41.5019 23.4076 41.5019 23.6574V28.2546C41.5019 28.4491 41.3984 28.6294 41.2306 28.7258L23.4767 38.9677C23.2304 39.1105 22.9234 38.9321 22.9234 38.6483H22.9216Z",
    fill: "#5747FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.2146 41.9177L55.327 47.0467V47.0378L64.2146 41.9177Z",
    fill: "#5747FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.4252 41.7892V41.7999L64.2235 41.9177L64.4252 41.7892Z",
    fill: "#5747FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmateLogo);
export default __webpack_public_path__ + "static/media/equipmate-logo.58114a811442fd36a7b00175f9a56a7b.svg";
export { ForwardRef as ReactComponent };